import { MarketingFooterLarge } from './marketing-footer-large';
import { MarketingFooterSmall } from './marketing-footer-small';

/**
 * MarketingFooter - `small` matches the original single-row landing footer;
 * `large` is the multi-column footer for full public pages (landing, use cases,
 * comparisons). The (marketing) layout uses `large`.
 */
export const MarketingFooter = ({ variant }: { variant: 'small' | 'large' }) =>
	variant === 'large' ? <MarketingFooterLarge /> : <MarketingFooterSmall />;
